import React, { useEffect } from 'react';
import Select, { CSSObjectWithLabel } from 'react-select';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';

import { Props as DefaultProps } from 'components/Common/FieldCustom/SelectFieldCustom/DefaultSelectRender';
import { Option } from 'components/Common/FieldCustom/SelectFieldCustom/SelectFieldCustom';

import styles from './SelectRender.module.scss';

type Props = DefaultProps<Option> & {
  forModal?: boolean;
};

export default function SelectRender({
  classes,
  forModal,
  ...props
}: Props): JSX.Element {
  const { menuIsOpen } = props;
  const isDesktop = useMediaQuery({ minWidth: 992 });

  useEffect(() => {
    document.body.classList[menuIsOpen ? 'add' : 'remove'](
      styles.popoverOpened
    );

    return () => {
      document.body.classList.remove(styles.popoverOpened);
    };
  }, [menuIsOpen]);

  return (
    <Select
      className={styles.selectContainer}
      classNames={{
        control: () =>
          classNames(styles.formControl, { [styles.open]: menuIsOpen }),
        option: state => {
          const option = state.data as Option;
          const customItemClass = option.classNames?.item;
          const isPlaceholder = option.isPlaceholder || false;

          return classNames(styles.item, classes?.item, {
            [styles.selectedItem]: state.isSelected,
            [styles.disabledItem]: state.isDisabled,
            [customItemClass as string]: undefined !== customItemClass,
            [styles.popoverPlaceholder]: isPlaceholder,
          });
        },
        valueContainer: () => styles.rootSelect,
        dropdownIndicator: () => styles.iconSelect,
        indicatorSeparator: () => styles.indicatorSeparator,
        menu: () => classNames(styles.paperPopover, styles.menu, classes?.menu),
        menuList: () => classNames(styles.menuList, classes?.menuList),
        singleValue: () => styles.placeholderSelected,
        menuPortal: () =>
          classNames(styles.rootPopover, classes?.openedContainer),
        placeholder: () => styles.placeholder,
      }}
      styles={{
        dropdownIndicator: (provided, state): CSSObjectWithLabel => ({
          ...provided,
          '& svg': { display: 'none' },
          transform: state.selectProps.menuIsOpen ? 'rotate(90deg)' : undefined,
        }),
      }}
      menuPortalTarget={!isDesktop || forModal ? document.body : undefined}
      {...props}
    />
  );
}
